module.exports = {
  china: {
    lang: "zh-CN", // 默认语言
    useLang: {
      "zh-CN": {
        label: "中",
        serverHeaderStr: "zh-CN"
      },
      "en-US": {
        label: "EN",
        serverHeaderStr: "en-US"
      }
    },
    countryCode: "+86",
    mobileReg: "^(08|8)[0-9]{8,14}$",
    currency: "元",
    currencySymbol: "￥",
    currencySeparator: ","
  },
  my: {
    lang: "ms-MY",
    useLang: {
      "zh-CN": {
        label: "中",
        serverHeaderStr: "zh-CN"
      },
      "en-US": {
        label: "EN",
        serverHeaderStr: "en-US"
      },
      "ms-MY": {
        label: "Malay",
        serverHeaderStr: "ms-MY"
      },
      "th-TH": {
        label: "ไทย",
        serverHeaderStr: "th-TH"
      },
      "vi-VN": {
        label: "Tiếng Việt",
        serverHeaderStr: "vi-VN"
      }
    },
    countryCode: "",
    mobileReg: "^(08|8)[0-9]{8,14}$",
    currency: "RM",
    currencySymbol: "RM",
    currencySeparator: ","
  }
};
